import { gql } from 'graphql-request';

const blogPost = gql`
  query fetchBlogPost($id: ID!) {
    blogPost(id: $id) {
      byline
      content
      title
      thumbnailImage
      updatedDate
    }
  }
`;

const homepageBlogPosts = gql`
  query fetchHomepageBlogPosts {
    homepageBlogPosts {
      id
      url
      description
      thumbnailImage
      title
    }
  }
`;

export const blogQueries = {
  blogPost,
  homepageBlogPosts,
};
